import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ViewSettingsCard from '../components/UserSettings/ViewSettingsCard';
import EditPasswordCard from '../components/UserSettings/EditPasswordCard';
import { UserSettingsSection } from '../constants/Enums';
import {
    changePasswordFailed,
    changePasswordSuccess,
    changingPassword,
    resetIsPasswordChanged
} from '../actions/AuthActions';
import { authServiceApiFactory } from '../auth/authServiceApiFactory';
import { useServiceApi } from '../hooks/services';

const UserSettingsController = () => {
    const user = useSelector(state => state.authenticationReducer.user);
    const error = useSelector(state => state.authenticationReducer.error
        ? state.authenticationReducer.error.message
        : null
    );
    const isPasswordChanged = useSelector(state => state.authenticationReducer.isPasswordChanged);

    const [state, setState] = useState({
        activeSection: UserSettingsSection.VIEW
    });

    const dispatch = useDispatch();
    const authServiceApi = useServiceApi(authServiceApiFactory);


    useEffect(() => {
        isPasswordChanged && dispatch(resetIsPasswordChanged());
        setState(prevState => ({
            ...prevState,
            activeSection: UserSettingsSection.VIEW
        }));
    }, [isPasswordChanged]);


    const setActiveSection = section => {
        setState(prevState => ({
            ...prevState,
            activeSection: section
        }));
    };

    const handleSaveButtonClick = (formData) => {
        if (!Object.values(formData).includes('')) { //TODO: need better validation here!!
            const { currentPassword, newPassword, confirmPassword } = formData;
            if (newPassword === confirmPassword) {
                dispatch(changingPassword());
                authServiceApi.changePassword(user.lwt.uid, currentPassword, newPassword).then(response => {
                    if (!response.error) {
                        dispatch(changePasswordSuccess());
                    } else {
                        const message = response.error.status === 500
                            ? 'Trouble connecting to Lone Wolf servers, please make sure you are ' +
                            'connected to the internet. If the problem persists, contact the ' +
                            'Lone Wolf Technologies support team.'
                            : response.error.body.message;
                        const e = {
                            ...response.error,
                            code: response.error.status,
                            message: message
                        };
                        dispatch(changePasswordFailed(e));
                    }
                })
            }
        }
    };

    return (
        <div className="container">
            {state.activeSection === UserSettingsSection.VIEW
                ? <ViewSettingsCard
                    username={user.username}
                    editPassword={() => setActiveSection(UserSettingsSection.EDIT)}
                />
                : <EditPasswordCard
                    user={user}
                    error={error}
                    isPasswordChangedSuccessfully={isPasswordChanged}
                    handleSaveButtonClick={handleSaveButtonClick}
                    handleCancelButtonClick={() => setActiveSection(UserSettingsSection.VIEW)}
                />
            }
        </div>
    );
};

export default UserSettingsController;